<template>
  <el-dialog
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-70 o-dialog-h--85"
    title="更新项目选用评估仪器"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-table
      ref="table"
      :data="pageRows"
      border
      height="100%"
      row-key="yqId"
      @select="selectRow"
      @select-all="selectPage"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
      />
      <el-table-column
        type="index"
        label="序号"
        width="60"
        align="center"
        :index="indexMethod"
      />
      <el-table-column
        prop="yqmc"
        label="设备名称"
        min-width="120"
      />
      <el-table-column
        prop="yqbh"
        label="设备编号"
        min-width="120"
      />
      <el-table-column
        prop="jdzsbh"
        label="检定/校准证书编号"
        min-width="160"
      />
      <el-table-column
        label="型号规格"
        min-width="140"
      >
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.xhgg" />
        </template>
      </el-table-column>
      <el-table-column
        label="用途"
        min-width="140"
      >
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.yt" />
        </template>
      </el-table-column>
      <el-table-column
        label="有效期起"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.jdyxqQ"
            type="date"
            value-format="timestamp"
            placeholder="请选择日期"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="有效期止"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ formatDate(scope.row.jdyxqZ) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="u-mg-t-10 u-text-right"
      :current-page.sync="pageNo"
      :page-size="pageSize"
      :total="options.length"
      layout="total, prev, pager, next"
      @current-change="restorePageSelection"
    />
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'JxxfPgInstrumentDialog',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialogShow: true,
      pageNo: 1,
      pageSize: 15,
      rows: [],
      selectedIds: new Set(this.selected.map(item => item.yqId))
    };
  },
  computed: {
    pageRows () {
      const start = (this.pageNo - 1) * this.pageSize;
      return this.rows.slice(start, start + this.pageSize);
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close');
    },
    indexMethod (index) {
      return (this.pageNo - 1) * this.pageSize + index + 1;
    },
    formatDate (value) {
      return value ? String(value).slice(0, 10) : '-';
    },
    selectRow (rows, row) {
      if (rows.some(item => item.yqId === row.yqId)) this.selectedIds.add(row.yqId);
      else this.selectedIds.delete(row.yqId);
    },
    selectPage (rows) {
      const selectedIds = new Set(rows.map(item => item.yqId));
      this.pageRows.forEach(item => {
        if (selectedIds.has(item.yqId)) this.selectedIds.add(item.yqId);
        else this.selectedIds.delete(item.yqId);
      });
    },
    restorePageSelection () {
      this.$nextTick(() => {
        this.pageRows.forEach(item => {
          this.$refs.table.toggleRowSelection(item, this.selectedIds.has(item.yqId));
        });
      });
    },
    handleSave () {
      const result = this.rows
        .filter(item => this.selectedIds.has(item.yqId))
        .map((item, index) => ({ ...item, dyxh: index + 1 }));
      this.$emit('save', result);
    }
  },
  created () {
    const existing = new Map(this.selected.map(item => [item.yqId, item]));
    this.rows = this.options.map(item => ({
      ...item,
      ...(existing.get(item.yqId) || {})
    }));
  },
  mounted () {
    this.restorePageSelection();
  }
};
</script>
